// Inter with its optical-size axis, so large headings get the display cut. Headings are sans; there's no serif any more.
import "@fontsource-variable/inter/opsz.css";
import "@fontsource-variable/jetbrains-mono";
import "./styles.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router";
import { queryClient } from "./api/queryClient";
import { applyCachedBrand } from "./lib/brand";
import { router } from "./router";
import { TooltipProvider } from "./ui/Tooltip";
import { ToastProvider } from "./ui/Toast";

// The last brand this browser saw, before anything paints; /api/brand confirms or replaces it.
applyCachedBrand();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={300}>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </TooltipProvider>
    </QueryClientProvider>
  </StrictMode>,
);
